module.exports = __webpack_public_path__ + "img/gerenciador-contas-linkedin-icon.28db0f42.svg";